module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "records-information row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.recordCount) ? _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("\n          " + _vm._s(_vm.recordCount) + " " + _vm._s(_vm.$tc('records.video', _vm.records.length >= 2 ? 2 : 1)) + "\n        ")]), _vm._v("\n        " + _vm._s(_vm.$tc('records.has_been_recorded', _vm.records.length >= 2 ? 2 : 1)) + "\n        "), (_vm.diversityTree) ? _c('span', [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "show dendrogram"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTree = !_vm.showTree
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "16px",
      "cursor": "pointer",
      "opacity": "0.7"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII=",
      "alt": "dendrogram"
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showTree) ? _c('dendrogram', {
    staticClass: "dendrogram",
    attrs: {
      "root": _vm.diversityTree
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "records row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.records.length),
      expression: "loading && !records.length"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), (_vm.records.length === 0 && !_vm.loading) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v(_vm._s(_vm.$t("records.none_available")))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.newRecordsCount > 0) ? _c('div', {
    staticClass: "alert new-record-avaible"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newRecordsCount))]), _vm._v("\n        " + _vm._s(_vm.$tc('records.new_available', _vm.newRecordsCount >= 2 ? 2 : 1)) + "\n        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.swapInNewRecords()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('records.click_here_to_refresh')))])]) : _vm._e()]), _vm._v(" "), _c('marker-tags-selector', {
    attrs: {
      "markerId": _vm.markerId
    },
    on: {
      "tags-selected": _vm.handleTagsSelected
    }
  }), _vm._v(" "), (_vm.isLmrConsumer) ? _c('lmr-city-report-filter', {
    on: {
      "change": _vm.handleLmrCitySelected
    },
    model: {
      value: (_vm.recordFilters.lmr_cities),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_cities", $$v)
      },
      expression: "recordFilters.lmr_cities"
    }
  }) : _vm._e(), _vm._v(" "), _c('inappropriate-filter', {
    on: {
      "change": function($event) {
        return _vm.fetchRecordCoords(true)
      }
    },
    model: {
      value: (_vm.recordFilters.inappropriate),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "inappropriate", $$v)
      },
      expression: "recordFilters.inappropriate"
    }
  }), _vm._v(" "), (_vm.isLmrConsumer) ? _c('lmr-category-filter', {
    on: {
      "change": function($event) {
        return _vm.fetchRecordCoords(true)
      }
    },
    model: {
      value: (_vm.recordFilters.lmr_category),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_category", $$v)
      },
      expression: "recordFilters.lmr_category"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "slider-color": "#ff2d55"
    },
    on: {
      "change": _vm.tabSelected
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("Approved")]), _vm._v(" "), _c('v-tab', [_vm._v("Deleted")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.markerId) ? [_c('div', {
    staticClass: "col-md-12 flex-container flex-stretch",
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "id": "marker-map-container"
    }
  }, [_c('marker-map', {
    staticStyle: {
      "flex": "1",
      "position": "relative",
      "z-index": "1"
    },
    attrs: {
      "image_coords": _vm.image_coords,
      "video_coords": _vm.video_coords
    },
    on: {
      "clicked-marker": _vm.handleClickedMarker,
      "map-moved": _vm.handleMapMoved
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.marker) ? _c('v-radio-group', {
    model: {
      value: (_vm.ordering),
      callback: function($$v) {
        _vm.ordering = $$v
      },
      expression: "ordering"
    }
  }, _vm._l((_vm.orderingItems), function(item) {
    return _c('v-radio', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      },
      on: {
        "change": _vm.changeOrdering
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('records-list', {
    attrs: {
      "records": _vm.records,
      "marker": _vm.marker
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row record-details"
  }, [(_vm.selectedRecord) ? _c('record-details', {
    attrs: {
      "record": _vm.selectedRecord,
      "marker-id": _vm.markerId
    },
    on: {
      "clicked-similar-record": _vm.showRecordDetails,
      "close": function($event) {
        _vm.selectedRecord = null
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.records.length),
      expression: "!loading && records.length"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('VIDEO'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('VIDEO')
      }
    },
    model: {
      value: (_vm.recordsPage),
      callback: function($$v) {
        _vm.recordsPage = $$v
      },
      expression: "recordsPage"
    }
  })], 1)], 1), _vm._v(" "), (_vm.imageRecords.length > 0) ? _c('div', [_c('div', [_c('h2', [_vm._v("Images")]), _vm._v(" "), _c('div', {
    staticClass: "row record-details"
  }, [_c('records-list', {
    attrs: {
      "records": _vm.imageRecords,
      "marker": _vm.marker
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.image_loading),
      expression: "!image_loading"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('IMAGE'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('IMAGE')
      }
    },
    model: {
      value: (_vm.imagesPage),
      callback: function($$v) {
        _vm.imagesPage = $$v
      },
      expression: "imagesPage"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "records-information related-records row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.relatedRecords.length > 0) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$tc('records.related_streams_title')))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_c('em', [_vm._v("\n            " + _vm._s(_vm.$tc('records.related_streams_help')) + "\n          ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "records related-records row"
  }, [_c('records-list', {
    attrs: {
      "records": _vm.relatedRecords,
      "read-only": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4819d66e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/MarkerRecords.vue
// module id = 1039
// module chunks = 1